application.register("comp_404", class extends Stimulus.Controller {
    connect() {
        this.element.classList.add("state--active");
    }
});